module.exports = __webpack_public_path__ + "img/please-your-min.4d9bf0ff.webp";